import { Column } from 'react-table'
import { columnGenerators } from '../../../../../../_metronic/helpers'

const header = (isFranchise = false, isSupplyChainManager = false) => [
  { label: 'S.N', value: 'id' },
  {
    label: 'Profile',
    value: 'bussinessPermit',
  },
  // {
  //   label: 'Name',
  //   value: 'name',
  // },
  /* {
    label: 'Birthday',
    value: 'birthday',
  },
  {
    label: 'Gender',
    value: 'gender',
  }, */
  /* {
    label: 'Email Address',
    value: 'email',
  }, */
  {
    label: 'Address',
    value: 'cityt',
  },
  {
    label: 'Country',
    value: 'countryt',
  },
  {
    label: 'Annual target',
    value: 'processingCapacity',
  },

  {
    label: 'Sold',
    value: '',
  },
  // {
  //   label: 'Sankey',
  //   value: 'sankey',
  // },
  {
    label: 'Certificate',
    value: 'CertificateTry',
  },
  {
    action: [
      'qr',
      ...((isSupplyChainManager && ['edit', 'delete']) || []),
      ...((isFranchise && ['edit', 'delete']) || []),
    ],
  },
  /*  {
    label: 'Joining Date',
    value: 'joinDate',
  },
  {
    label: 'Current Level',
    value: 'currentLevel',
  },
  {
    label: 'Points Earned',
    value: 'pointEarned',
  },
  {
    label: 'Redeemed',
    value: 'pointRedeemed',
  }, */
]

const roleColumns = (isFranchise = false, isSupplyChainManager = false) => {
  return columnGenerators(header(isFranchise, isSupplyChainManager))
}
export { roleColumns }
